import { render, staticRenderFns } from "./InflowImpossible.vue?vue&type=template&id=bd33b024&scoped=true&"
import script from "./InflowImpossible.vue?vue&type=script&lang=js&"
export * from "./InflowImpossible.vue?vue&type=script&lang=js&"
import style0 from "./InflowImpossible.vue?vue&type=style&index=0&id=bd33b024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd33b024",
  null
  
)

export default component.exports